const useRandomizedArray = (array: any[]) => {
  const newArray = array.slice()
  // Fisher-Yates (aka Knuth) Shuffle algorithm
  for (let indexA = newArray.length - 1; indexA > 0; indexA--) {
    const indexB = Math.floor(Math.random() * (indexA + 1))
    ;[newArray[indexA], newArray[indexB]] = [newArray[indexB], newArray[indexA]]
  }

  return newArray
}

export default useRandomizedArray
